// Auth

export const AUTHENTICATED = 'AUTHENTICATED';
export const SIGNED_OUT = 'SIGNED_OUT';
export const AUTH_EXPIRED = 'AUTH_EXPIRED';

export const AUTH_INIT = 'AUTH_INIT';
export const AUTH_INIT_SUCCESS = 'AUTH_INIT_SUCCESS';
export const AUTH_INIT_ERROR = 'AUTH_INIT_ERROR';

export const AUTH_SIGN_IN = 'AUTH_SIGN_IN';
export const AUTH_SIGN_IN_SUCCESS = 'AUTH_SIGN_IN_SUCCESS';
export const AUTH_SIGN_IN_ERROR = 'AUTH_SIGN_IN_ERROR';

export const AUTH_SIGN_OUT = 'AUTH_SIGN_OUT';
export const AUTH_SIGN_OUT_SUCCESS = 'AUTH_SIGN_OUT_SUCCESS';
export const AUTH_SIGN_OUT_ERROR = 'AUTH_SIGN_IN_ERROR';
